export const createCSV = (data, fileName) => {
  const csv = encodeURI(`data:text/csv;charset=utf-8,${data}`)

  const link = document.createElement('a')
  link.setAttribute('href', csv)
  link.setAttribute('download', fileName)
  link.click()
}
